'use client'

import { useLoanComparatorStore } from '@/app/stores/loan/loan-comparator.store'
import { describePromoDiscount } from '@/app/utils/loan/promo-code'
import AppIcon from '@/app/components/atomic/AppIcon'

// A code from a partner link is applied on quote creation, before the visitor reaches the identity step
export default function LoanPromoStepReminder() {
    const quote = useLoanComparatorStore((state) => state.quote)
    const promo = quote?.promo_code ?? null
    if (!promo) return null

    return (
        <div
            className="mb-4 flex items-center gap-2 rounded-xl border border-[#CFE3D0] bg-[#EEF7EF] px-3 py-2 text-[14px] text-[#1F6B36] md:mb-6"
            role="status"
            data-testid="loan-promo-step-reminder"
        >
            <AppIcon iconClassName="fa-ticket" size="sm" type="regular" />
            <span>
                <strong>Code {promo.code} appliqué</strong> · {describePromoDiscount(quote, false)}
            </span>
        </div>
    )
}
